import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";

import { Button } from "../Buttons";

import "./quatroGrid.scss";

function QuatroGrid({
  title,
  children,
  viewType,
  customClassName,
  ifPagination,
  paginationClick
}) {
  const { t } = useTranslation();
  const quatroGridClasses = classNames({
    quatroGrid: true,
    wideGrid: viewType === "wide",
    [customClassName]: customClassName,
  });

  return (
    <section className={quatroGridClasses}>
      <h2>{title}</h2>
      <ul className="quatroGridList">{children}</ul>
      {ifPagination && (
        <div className="paginationBtnBlock">
          <Button viewType="cancelBtn" label={t("viewMore")} onClick={() => paginationClick()} />
        </div>
      )}
    </section>
  );
}

QuatroGrid.propTypes = {
  viewType: PropTypes.oneOf(["wide"]),
  title: PropTypes.string,
  ifPagination: PropTypes.bool,
  customClassName: PropTypes.string,
  paginationClick: PropTypes.func,
};

QuatroGrid.defaultProps = {
  title: "",
  children: "",
  customClassName: "",
  ifPagination: false,
};

export default QuatroGrid;
